module.exports = __webpack_public_path__ + "assets/img/sunrise-solar.080663f9.webp";